import { getLegacyId } from '@nerdwallet/marketplace/selectors/common';
export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return {
    // Override with legacy ID for tracking continuity :(
    // @todo This is a product req that we should updated ASAP.
    productId: getLegacyId(marketplaceEntity),
    text: 'Get Rate',
    vertical: 'Personal Loans'
  };
});